import { createAction } from 'redux-actions';
import Types from './types';

export const modalOpen = createAction(Types.MODAL_OPEN);
export const modalClose = createAction(Types.MODAL_CLOSE);
